
import React, { useEffect } from 'react';
import { Card, CardImg, Col, Container, Row } from 'reactstrap';

function NuestrosProgramas(props){ 

    useEffect(() => {
        if (window.location.hash){
            const el = document.getElementById(`${window.location.hash}`);
            if (el) {
                const offset = 80;
                const top = el.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        }
        
      }, [])
    return (
        <>
            <section className="section section-lg pt-6 bg-secondary mt-5">
            <Container>
              <Row className="row-grid align-items-center mb-5" id="nuestrosProgramas">
                <Col lg="12">
                  <div className="align-component-enter">
                      <h4 className="display-3">Dispositivos de trabajo</h4>
                      <p className="align-component-justify lead">
                        Cada usuario del Centro de Dia junto con el equipo interdisciplinario realiza una planificación centrada en la persona, seleccionando las actividades, espacios y talleres de trabajo, a través de los apoyos que cada uno necesita. Los objetivos del plan personal tienen en cuenta las dimensiones Bienestar emocional, Relaciones interpersonales, Bienestar material, Desarrollo personal, Bienestar físico, Autodeterminación, Inclusión social y Derechos 
                      </p>
                  </div>
                </Col>
              </Row>
              <Row id="#autodeterminacion" className="mb-6">
                <Col md="6" className="order-last order-md-first">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="Dispositivo de Autonomía y Autodeterminación"
                      src={require("assets/img/theme/talleres/autodeterminacion.jpg")}
                      top
                    />
                  </Card>
                </Col>
                <Col md="6" className="order-last order-sm-first">
                  <div className="pl-md-5">
                    <h3>1. Dispositivo de Autonomía y Autodeterminación</h3>
                    <p>
                      Promueve el desarrollo de habilidades personales que favorezcan la toma de decisiones, la expresión de preferencias, la autorregulación emocional y el ejercicio efectivo de derechos.
                    </p>
                    <p>
                      La autodeterminación se concibe como un proceso dinámico que integra habilidades, conocimientos, actitudes y creencias que posibilitan conductas autónomas, autorreguladas y orientadas a metas personales.
                    </p>
                    <p>
                      Este dispositivo promueve el desarrollo de competencias para la toma de decisiones, la autorregulación emocional, la resolución de problemas, la autoafirmación y el ejercicio efectivo de derechos, fortaleciendo la autoconfianza, la autoestima y el sentido de agencia personal.
                    </p>
                    <p>
                      Se implementan estrategias sistemáticas orientadas a que los usuarios participen activamente en la elección de actividades, la planificación de rutinas, la definición de objetivos personales y la evaluación de sus propios logros, respetando sus tiempos, preferencias y singularidades.
                    </p>
                    <p>Resultados esperados:</p>
                    <ul>
                      <li>Mayor participación en la toma de decisiones.</li>
                      <li>Expresión clara de necesidades.</li>
                      <li>Incremento progresivo de la autonomía.</li>
                      <li>Fortalecimiento de la autoconfianza.</li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row id="#transicion-vida-adulta" className="mb-6">
                <Col md="6" className="order-last order-sm-first">
                  <div className="pl-md-5">
                    <h3>2. Dispositivo Proyecto de Vida y Transición a la Vida Adulta</h3>
                    <p>
                      La transición a la vida adulta se aborda como un proceso integral, continuo y multidimensional, orientado al desarrollo progresivo de competencias necesarias para la participación autónoma en los distintos ámbitos de la vida social.
                    </p>
                    <p>
                      Este programa incluye el trabajo sistemático sobre habilidades de la vida diaria, autocuidado, manejo del entorno, movilidad, comunicación funcional, habilidades sociales, organización personal y desempeño ocupacional.
                    </p>
                    <p>
                      Las intervenciones se planifican de manera gradual, respetando los ritmos individuales, con el objetivo de favorecer trayectorias de vida adulta más autónomas, participativas y con mayores niveles de inclusión social.
                    </p>
                    <p>Resultados esperados:</p>
                    <ul>
                      <li>Mayor autonomía en actividades de la vida diaria.</li>
                      <li>Incremento de la participación comunitaria.</li>
                      <li>Mejora en habilidades sociales.</li>
                      <li>Desarrollo de competencias para la vida adulta.</li>
                      <li>Mejora en la organización personal.</li>
                    </ul>
                  </div>
                </Col>
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="Dispositivo Proyecto de Vida y Transición a la Vida Adulta"
                      src={require("assets/img/theme/talleres/vida-adulta-transicion.jpg")}
                      top
                    />
                  </Card>
                </Col>
              </Row>
              <Row id="#formacion-laboral" className="mb-6">
                <Col md="6" className="order-last order-md-first">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="Dispositivo de Formación Ocupacional y Desarrollo laboral"
                      src={require("assets/img/theme/talleres/formacion-laboral.jpg")}
                      top
                    />
                  </Card>
                </Col>
                <Col md="6" className="order-last order-sm-first">
                  <div className="pl-md-5">
                    <h3>3. Dispositivo de Formación Ocupacional y Desarrollo laboral</h3>
                    <p>
                      Este dispositivo tiene como objetivo brindar oportunidades sistemáticas de capacitación y entrenamiento en competencias laborales, a través de la implementación de talleres ocupacionales y productivos con modalidad de autogestión, adaptados a los distintos perfiles de apoyo.
                    </p>
                    <p>
                      La propuesta incluye instancias de formación teórico-práctica orientadas al desarrollo de hábitos laborales, responsabilidad, puntualidad, trabajo en equipo, resolución de problemas, cumplimiento de normas, cuidado de materiales y calidad en la producción.
                    </p>
                    <p>
                      Asimismo, se promueve la adquisición de competencias laborales generales, el desarrollo personal, el bienestar emocional y la autodeterminación.
                    </p>
                    <p>Resultados esperados:</p>
                    <ul>
                      <li>Desarrollo de competencias laborales básicas.</li>
                      <li>Incremento de la autonomía productiva.</li>
                      <li>Fortalecimiento de la identidad ocupacional.</li>
                      <li>Mejora en la participación en entornos productivos.</li>
                      <li>Incorporación de hábitos ocupacionales.</li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row id="#inclusion-social" className="mb-6">
                <Col md={6} className="order-last order-sm-first">
                  <div className="pl-md-5">
                    <h3>4. Dispositivo Vida en la comunidad e Inclusión Social</h3>
                    <p>
                      Este dispositivo promueve y facilita la participación activa de los usuarios en espacios sociales, culturales, recreativos, artísticos y deportivos, tanto dentro como fuera del ámbito institucional, favoreciendo experiencias de interacción significativa con la comunidad.
                    </p>
                    <p>
                      Se organizan salidas, visitas educativas, actividades culturales y recreativas, proyectos comunitarios y acciones conjuntas con organizaciones del territorio y actores comunitarios, orientadas al fortalecimiento de la inclusión social, el sentido de pertenencia y la ampliación de redes sociales.
                    </p>
                    <p>
                      Estas propuestas favorecen el desarrollo de habilidades sociales, la construcción de la identidad personal y social, la autoestima y el bienestar emocional, promoviendo procesos de integración genuina y sostenida.
                    </p>
                    <p>Resultados esperados:</p>
                    <ul>
                      <li>Ampliación de redes sociales y comunitarias.</li>
                      <li>Incremento de la participación social.</li>
                      <li>Mejora en la calidad de vida y el bienestar subjetivo.</li>
                    </ul>
                  </div>
                </Col>
                <Col md={6}>
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="Dispositivo Vida en la comunidad e Inclusión Social"
                      src={require("assets/img/theme/talleres/inclusion-social.jpg")}
                      top
                    />
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </>
    );
}
export default NuestrosProgramas;